/**
 * Component Product Form New - Unminified Version
 * Handles subscription and one-time purchase forms with Loop integration
 */

// Currency utilities
function getCurrencySettings() {
  const countrySelect = document.querySelector("#country_code");
  
  if (countrySelect) {
    const selectedOption = countrySelect.options[countrySelect.selectedIndex].text;
    const match = selectedOption.match(/\((\w+)\s+([^\w\s]+)\)/);
    
    if (match) {
      const [, currencyCode, currencySymbol] = match;
      return {
        currencyCode: currencyCode,
        currencySymbol: currencySymbol,
        isUSMarket: currencyCode === "USD",
        moneyFormat: "{{amount_no_decimals}}"
      };
    } else {
                      return {
        currencyCode: "USD",
        currencySymbol: "$",
        isUSMarket: true,
        moneyFormat: "{{amount_no_decimals}}"
      };
    }
  } else {
                          return {
      currencyCode: "USD",
      currencySymbol: "$",
      isUSMarket: true,
      moneyFormat: "{{amount_no_decimals}}"
    };
  }
}

function getPriceWithCurrency(price, currencySettings, moneyFormat) {
  if (typeof price === "string") {
    price = parseFloat(price.replace(",", ".")) || 0;
  }
  
  const currencyCode = currencySettings.currencyCode || "USD";
  const currencySymbol = currencySettings.currencySymbol || "$";
  const isUSMarket = currencySettings.isUSMarket !== undefined ? currencySettings.isUSMarket : true;
  
  const formattedPrice = formatPrice(price, 0, isUSMarket ? "," : ".");
  
  return isUSMarket ? `${currencySymbol}${formattedPrice}` : `${currencySymbol}${formattedPrice} ${currencyCode}`;
}

function formatPrice(price, decimals = 0, thousandsSeparator = ",") {
  if (isNaN(price) || price === null) return "0";
  
  const fixedPrice = Math.round(price).toFixed(decimals);
  return fixedPrice.replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${thousandsSeparator}`);
}

// Pricing calculations
function getDiscountPercent(quantity, purchaseType, productType) {
  if (purchaseType === "one_time") {
    return quantity === 2 ? 5 : quantity === 4 ? 10 : 0;
  }
  
  if (productType === "system") {
    return 25;
  }
  
  // Subscription prices: 1 jar = R$59 (33.7%), 2 jars = R$56 (37.1%), 4 jars = R$53.10 (40.34%)
  // Using precise percentages for accurate calculations
  return quantity === 1 ? 33.7 : quantity === 2 ? 37.1 : quantity === 4 ? 40.34 : 0;
}

function calculatePrices(basePrice, quantity, purchaseType, productType, compareAtPrice) {
  // Use correct base price (R$89)
  if (isNaN(basePrice) || basePrice <= 0) basePrice = 89;
  if (isNaN(compareAtPrice) || compareAtPrice <= 0) compareAtPrice = basePrice;
  
  const discountPercent = getDiscountPercent(quantity, purchaseType, productType);
  
  // Calculate precise price without rounding during calculation
  const pricePerUnit = basePrice * (1 - discountPercent / 100);
  const totalPrice = pricePerUnit * quantity;
  const comparePrice = productType === "system" ? Number(compareAtPrice) : basePrice * quantity;
  
  return {
    price: Math.round(totalPrice).toFixed(0),
    compareAtPrice: Math.round(comparePrice).toFixed(0),
    discountPercent: Math.round(discountPercent * 10) / 10, // Round to 1 decimal
    pricePerUnit: Math.round(pricePerUnit) // For data attributes
  };
}

// UI Updates
function updateDiscountLabels(purchaseType, quantity, productType) {
  const savePercentage = document.querySelector("#save-percentage");
  const saveSubscription = document.querySelector("#save-subscription");
  const save40 = document.querySelector("#save-40");
  const subscriptionLabels = document.querySelectorAll(".js-discount-label-subscription");
  const noSubscriptionLabels = document.querySelectorAll(".js-discount-label-no-subscription");
  
  if (productType === "system") {
    if (purchaseType === "one_time") {
      if (savePercentage) savePercentage.style.display = "inline";
      if (save40) save40.style.display = "none";
    } else if (purchaseType === "subscription") {
      if (savePercentage) savePercentage.style.display = "none";
      if (save40) save40.style.display = "inline";
    }
  } else {
    if (purchaseType === "one_time") {
      if (saveSubscription) saveSubscription.style.display = "none";
      subscriptionLabels.forEach(label => label.classList.add("is-hidden"));
      
      if (quantity === 1) {
        if (savePercentage) savePercentage.style.display = "none";
      } else if (quantity === 2) {
        if (savePercentage) {
          savePercentage.textContent = "Save 5%";
          savePercentage.style.display = "inline";
        }
      } else if (quantity === 3) {
        if (savePercentage) {
          savePercentage.textContent = "Save 10%";
          savePercentage.style.display = "inline";
        }
      }
      
      noSubscriptionLabels.forEach(label => label.classList.remove("is-hidden"));
    } else if (purchaseType === "subscription") {
      if (savePercentage) savePercentage.style.display = "none";
      noSubscriptionLabels.forEach(label => label.classList.add("is-hidden"));
      
       if (quantity === 1) {
         if (saveSubscription) saveSubscription.textContent = "Save 34%";
       } else if (quantity === 2) {
         if (saveSubscription) saveSubscription.textContent = "Save 37%";
       } else if (quantity === 4) {
         if (saveSubscription) saveSubscription.textContent = "Save 42%";
       }
      
      if (saveSubscription) saveSubscription.style.display = "inline";
      subscriptionLabels.forEach(label => label.classList.remove("is-hidden"));
    }
  }
}

function updatePriceDisplay(masterButton, priceData, priceFormatter, currencySettings) {
  const mainPriceElement = masterButton.querySelector(".js-subscribtion__option-price .js-subscribtion__main-price");
  const comparePriceElement = masterButton.querySelector(".js-subscribtion__option-price .js-subscribtion__compare-at-price");
  
  if (mainPriceElement) {
    const formattedPrice = priceFormatter(priceData.price, currencySettings);
    mainPriceElement.textContent = formattedPrice;
  }
  
  if (comparePriceElement) {
    const formattedComparePrice = priceFormatter(priceData.compareAtPrice, currencySettings);
    comparePriceElement.textContent = formattedComparePrice;
    comparePriceElement.classList.toggle("is-hidden", priceData.price === priceData.compareAtPrice);
  }
}

function updateAddToCartButton(button, price, priceFormatter, currencySettings, priceData = null) {
  const priceElement = button.querySelector(".js-subscribtion__main-price");
  const totalPriceElement = button.querySelector(".js-subscribtion__total-price");
  
  if (priceElement) {
    const formattedPrice = priceFormatter(price, currencySettings);
    priceElement.textContent = formattedPrice;
    
    // Store price data in data attributes
    if (priceData) {
      priceElement.setAttribute('data-price-total', price);
      priceElement.setAttribute('data-price-per-unit', priceData.pricePerUnit || price);
      priceElement.setAttribute('data-discount-percent', priceData.discountPercent || 0);
    }
  }
  
  // Update the total price in the button text
  if (totalPriceElement) {
    const formattedPrice = priceFormatter(price, currencySettings);
    totalPriceElement.textContent = formattedPrice;
    
    // Store price data in data attributes
    if (priceData) {
      totalPriceElement.setAttribute('data-price-total', price);
      totalPriceElement.setAttribute('data-price-per-unit', priceData.pricePerUnit || price);
      totalPriceElement.setAttribute('data-discount-percent', priceData.discountPercent || 0);
    }
  }
  
  if (window.PubSub && typeof window.PubSub.publish === "function") {
    window.PubSub.publish("updateAddToCartButton", price);
  }
}

function updatePurchaseTypeButtons(basePrice, quantity, currencySettings, productType) {  
  // Calculate prices for both purchase types
  const oneTimePriceData = calculatePrices(basePrice, quantity, "one_time", productType, basePrice);
  const subscriptionPriceData = calculatePrices(basePrice, quantity, "subscription", productType, basePrice);
  
  // Calculate compare at price: full price without any discount (basePrice * quantity)
  const fullPriceWithoutDiscount = basePrice * quantity;
    
  // Update one-time purchase button price
  const oneTimePriceElement = document.querySelector(".js-one-time-main-price");
  if (oneTimePriceElement) {
    const formattedPrice = getPriceWithCurrency(oneTimePriceData.price, currencySettings);
    oneTimePriceElement.textContent = formattedPrice;
  }
  
  // Update subscription button price  
  const subscriptionPriceElement = document.querySelector(".js-subscription-main-price");
  if (subscriptionPriceElement) {
    const formattedPrice = getPriceWithCurrency(subscriptionPriceData.price, currencySettings);
    subscriptionPriceElement.textContent = formattedPrice;
  }
  
  // Update subscription compare at price (full price without discount)
  const subscriptionComparePriceElement = document.querySelector(".js-subscription-compare-price");
  if (subscriptionComparePriceElement) {
    const formattedComparePrice = getPriceWithCurrency(fullPriceWithoutDiscount, currencySettings);
    subscriptionComparePriceElement.textContent = formattedComparePrice;
    
    // Show/hide based on price difference
    const shouldShowSubscriptionCompare = parseFloat(fullPriceWithoutDiscount) > parseFloat(subscriptionPriceData.price);
    subscriptionComparePriceElement.style.display = shouldShowSubscriptionCompare ? '' : 'none';
  }
  
  // Update one-time compare at price (full price without discount) - NEW
  const oneTimeComparePriceElement = document.querySelector(".js-one-time-compare-price");
  if (oneTimeComparePriceElement) {
    const formattedComparePrice = getPriceWithCurrency(fullPriceWithoutDiscount, currencySettings);
    oneTimeComparePriceElement.textContent = formattedComparePrice;
    
    // Show/hide based on price difference
    const shouldShowOneTimeCompare = parseFloat(fullPriceWithoutDiscount) > parseFloat(oneTimePriceData.price);
    oneTimeComparePriceElement.style.display = shouldShowOneTimeCompare ? '' : 'none';
  }
}

// Subscription Component
class SubscriptionComponent extends HTMLElement {
  constructor() {
    super();
    this.elements = {};
    this.state = {};
    this.currencySettings = getCurrencySettings();
  }

  connectedCallback() {
    this.initializeElements();
    this.setupEventListeners();
    this.initializeState();
  }

  initializeElements() {
    this.elements = {
      form: this.querySelector(".js-subscribtion__subscription-form"),
      purchaseTypeRadios: this.querySelectorAll('input[name="purchase_type"]'),
      quantityRadios: this.querySelectorAll('input[name="quantity"]'),
      variantRadios: this.querySelectorAll('input[name="id"]'),
      sellingPlanFieldset: this.querySelector("#selling-plan-fieldset"),
      addToCartButton: this.querySelector(".js-subscribtion__add-to-cart")
    };
  }

  initializeState() {
    const sellingPlanForm = this.querySelector("#selling-plan-form");
    this.variants = sellingPlanForm && sellingPlanForm.dataset.variants ? 
      JSON.parse(sellingPlanForm.dataset.variants) : [];
    
    const basePrice = Number(this.dataset.price);
    const compareAtPrice = Number(this.dataset.compareAtPrice);
    
    const selectedVariantId = this.elements.variantRadios.length ? 
      Array.from(this.elements.variantRadios).find(radio => radio.checked)?.value :
      this.elements.form.querySelector('input[name="id"]')?.value;
    
    const selectedVariant = this.variants.find(variant => variant.id === parseInt(selectedVariantId)) || 
      { price: 100 * basePrice, compare_at_price: 100 * compareAtPrice };
    
    const selectedPurchaseType = Array.from(this.elements.purchaseTypeRadios).find(radio => radio.checked);
    const selectedQuantity = Array.from(this.elements.quantityRadios).find(radio => radio.checked);
    
    this.state = {
      basePrice: selectedVariant.price / 100,
      compareAtPrice: selectedVariant.compare_at_price ? selectedVariant.compare_at_price / 100 : selectedVariant.price / 100,
      productType: this.dataset.productType || "default",
      quantity: selectedQuantity ? parseInt(selectedQuantity.value) : 1,
      purchaseType: selectedPurchaseType?.value || "subscription",
      masterButton: selectedPurchaseType?.parentElement
    };
    
    // Initialize discount labels
    updateDiscountLabels(this.state.purchaseType, this.state.quantity, this.state.productType);
    
    // Initialize button price
    const priceData = calculatePrices(
      Number(this.state.basePrice),
      this.state.quantity,
      this.state.purchaseType,
      this.state.productType,
      this.state.compareAtPrice
    );
    
    updateAddToCartButton(this.elements.addToCartButton, priceData.price, getPriceWithCurrency, this.currencySettings, priceData);
    
    // Initialize purchase type button prices
    updatePurchaseTypeButtons(Number(this.state.basePrice), this.state.quantity, this.currencySettings, this.state.productType);
    
    // Initialize selling plan fieldset visibility
    if (this.elements.sellingPlanFieldset) {
      if (this.state.purchaseType === "subscription") {
        this.elements.sellingPlanFieldset.style.display = 'flex';
      } else {
        this.elements.sellingPlanFieldset.style.display = 'none';
      }
    }
  }

  setupEventListeners() {
    // Purchase type change handler
    this.handlePurchaseTypeChange = (event) => {
      const radio = event.target.closest('input[name="purchase_type"]');
      if (!radio) return;
      
      const purchaseType = radio.value;
      this.state = {
        ...this.state,
        purchaseType: purchaseType,
        masterButton: radio.parentElement
      };
      
      // Handle selling plan when switching purchase types
      const sellingPlanHiddenInput = this.elements.form.querySelector('.js-selling-plan-input');
      
      if (purchaseType === "subscription") {
        // Show selling plan options
        this.elements.sellingPlanFieldset.style.display = 'flex';
        
        // Ensure the first selling plan is selected when switching to subscription
        const firstSellingPlan = this.elements.sellingPlanFieldset.querySelector('input[name="selling_plan_radio"]');
        if (firstSellingPlan && !firstSellingPlan.checked) {
          firstSellingPlan.checked = true;
          // Update hidden input
          if (sellingPlanHiddenInput) {
            sellingPlanHiddenInput.value = firstSellingPlan.value;
          }
        }
      } else {
        // Hide selling plan options for one-time purchase
        this.elements.sellingPlanFieldset.style.display = 'none';
        
        // Clear selling plan for one-time purchase
        const sellingPlanInputs = this.elements.sellingPlanFieldset.querySelectorAll('input[name="selling_plan_radio"]');
        sellingPlanInputs.forEach(input => input.checked = false);
        // Clear hidden input
        if (sellingPlanHiddenInput) {
          sellingPlanHiddenInput.value = '';
        }
      }
      
      // Update discount labels and prices
      updateDiscountLabels(purchaseType, this.state.quantity, this.state.productType);
      const priceData = calculatePrices(
        Number(this.state.basePrice),
        this.state.quantity,
        purchaseType,
        this.state.productType,
        this.state.compareAtPrice
      );
      
      updatePriceDisplay(this.state.masterButton, priceData, getPriceWithCurrency, this.currencySettings);
      updateAddToCartButton(this.elements.addToCartButton, priceData.price, getPriceWithCurrency, this.currencySettings, priceData);
    };

    // Quantity change handler
    this.handleQuantityChange = () => {
      const selectedQuantity = Number(
        Array.from(this.elements.quantityRadios).find(radio => radio.checked)?.value || 1
      );
      
      this.state = {
        ...this.state,
        quantity: selectedQuantity
      };
      
      const priceData = calculatePrices(
        Number(this.state.basePrice),
        selectedQuantity,
        this.state.purchaseType,
        this.state.productType,
        this.state.compareAtPrice
      );
      
      updatePriceDisplay(this.state.masterButton, priceData, getPriceWithCurrency, this.currencySettings);
      updateAddToCartButton(this.elements.addToCartButton, priceData.price, getPriceWithCurrency, this.currencySettings, priceData);
      updateDiscountLabels(this.state.purchaseType, selectedQuantity, this.state.productType);
      
      // Update purchase type button prices based on new quantity
      updatePurchaseTypeButtons(Number(this.state.basePrice), selectedQuantity, this.currencySettings, this.state.productType);
    };

    // Variant change handler
    this.handleVariantChange = (event) => {
      const radio = event.target.closest('input[name="id"]');
      if (!radio) return;
      
      const variantId = parseInt(radio.value);
      const variant = this.variants.find(v => v.id === variantId);
      
      if (variant) {
        this.state = {
          ...this.state,
          basePrice: variant.price / 100,
          compareAtPrice: variant.compare_at_price ? variant.compare_at_price / 100 : variant.price / 100
        };
        
        const priceData = calculatePrices(
          Number(this.state.basePrice),
          this.state.quantity,
          this.state.purchaseType,
          this.state.productType,
          this.state.compareAtPrice
        );
        
        updatePriceDisplay(this.state.masterButton, priceData, getPriceWithCurrency, this.currencySettings);
        updateAddToCartButton(this.elements.addToCartButton, priceData.price, getPriceWithCurrency, this.currencySettings, priceData);
        updateDiscountLabels(this.state.purchaseType, this.state.quantity, this.state.productType);
        
        // Update hidden form input
        const hiddenInput = this.elements.form.querySelector('input[name="id"]');
        if (hiddenInput) {
          hiddenInput.value = variantId;
        }
      }
    };

    // Form submit handler
    this.handleFormSubmit = async (event) => {
      event.preventDefault();
      
      const originalButtonText = this.elements.addToCartButton.innerHTML;
      this.elements.addToCartButton.innerHTML = "Adding...";
      
      try {
        const formData = new FormData(this.elements.form);
        
        // Remove selling_plan if one-time purchase
        if (formData.get("purchase_type") === "one_time") {
          formData.delete("selling_plan");
        }
        
        const response = await fetch("/cart/add.js", {
          method: "POST",
          body: formData
        });
        
        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(errorData.message);
        }
        
        const cartData = await response.json();
        
        // Update cart UI
        document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
          bubbles: true,
          detail: { cart: cartData, openMiniCart: true }
        }));
        
        if (typeof updateCartItemCount === "function") {
          updateCartItemCount();
        }
        
        if (window.PubSub && typeof window.PubSub.publish === "function") {
          window.PubSub.publish("close-sticky-form");
        }
        
      } catch (error) {
        console.error("Subscription cart add error:", error);
      } finally {
        this.elements.addToCartButton.innerHTML = originalButtonText;
      }
    };

    // Selling plan change handler (delivery frequency)
    this.handleSellingPlanChange = (event) => {
      const radio = event.target.closest('input[name="selling_plan_radio"]');
      if (!radio) return;
      
      // Update the hidden selling plan input that will be submitted
      const sellingPlanInput = this.elements.form.querySelector('.js-selling-plan-input');
      if (sellingPlanInput) {
        sellingPlanInput.value = radio.value;
      }
    };

    // Country change handler
    this.handleCountryChange = () => {
      this.currencySettings = getCurrencySettings();
      const priceData = calculatePrices(
        Number(this.state.basePrice),
        this.state.quantity,
        this.state.purchaseType,
        this.state.productType,
        this.state.compareAtPrice
      );
      
      updatePriceDisplay(this.state.masterButton, priceData, getPriceWithCurrency, this.currencySettings);
      updateAddToCartButton(this.elements.addToCartButton, priceData.price, getPriceWithCurrency, this.currencySettings, priceData);
    };

    // Add event listeners
    this.elements.purchaseTypeRadios.forEach(radio => {
      radio.addEventListener("change", this.handlePurchaseTypeChange);
    });
    
    this.elements.quantityRadios.forEach(radio => {
      radio.addEventListener("change", this.handleQuantityChange);
    });
    
    this.elements.variantRadios.forEach(radio => {
      radio.addEventListener("change", this.handleVariantChange);
    });
    
    // Add selling plan event listeners
    const sellingPlanRadios = this.elements.sellingPlanFieldset.querySelectorAll('input[name="selling_plan_radio"]');
    sellingPlanRadios.forEach(radio => {
      radio.addEventListener("change", this.handleSellingPlanChange);
    });

    // Add click handlers for selling plan labels (same as quantity options)
    const sellingPlanLabels = this.elements.sellingPlanFieldset.querySelectorAll('.c-subscribtion__quantity-option');
    sellingPlanLabels.forEach(label => {
      label.addEventListener('click', function() {
        const input = this.querySelector('input[type="radio"]');
        if (input && !input.checked) {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });
    
    this.elements.form.addEventListener("submit", this.handleFormSubmit);
    
    const countrySelect = document.querySelector("#country_code");
    if (countrySelect) {
      countrySelect.addEventListener("change", this.handleCountryChange);
    }
  }

  disconnectedCallback() {
    // Remove event listeners
    this.elements.purchaseTypeRadios.forEach(radio => {
      radio.removeEventListener("change", this.handlePurchaseTypeChange);
    });
    
    this.elements.quantityRadios.forEach(radio => {
      radio.removeEventListener("change", this.handleQuantityChange);
    });
    
    this.elements.variantRadios.forEach(radio => {
      radio.removeEventListener("change", this.handleVariantChange);
    });
    
    // Remove selling plan event listeners
    const sellingPlanRadios = this.elements.sellingPlanFieldset.querySelectorAll('input[name="selling_plan_radio"]');
    sellingPlanRadios.forEach(radio => {
      radio.removeEventListener("change", this.handleSellingPlanChange);
    });

    // Remove selling plan label click handlers
    const sellingPlanLabels = this.elements.sellingPlanFieldset.querySelectorAll('.c-subscribtion__quantity-option');
    sellingPlanLabels.forEach(label => {
      label.removeEventListener('click', this.handleSellingPlanChange);
    });
    
    this.elements.form.removeEventListener("submit", this.handleFormSubmit);
    
    const countrySelect = document.querySelector("#country_code");
    if (countrySelect) {
      countrySelect.removeEventListener("change", this.handleCountryChange);
    }
  }
}

// Register the custom element
if (!customElements.get("c-subscription")) {
  customElements.define("c-subscription", SubscriptionComponent);
}

// Initialize on DOM ready
document.addEventListener("DOMContentLoaded", function() {
  // Enhanced quantity selector functionality and initial state correction
  const subscriptionComponent = document.querySelector('c-subscription');
  if (!subscriptionComponent) return;

  // Fix initial state - ensure subscription prices are shown when subscription is selected
  setTimeout(function() {
    const subscriptionRadio = subscriptionComponent.querySelector('input[name="purchase_type"][value="subscription"]');
    const oneTimeRadio = subscriptionComponent.querySelector('input[name="purchase_type"][value="one_time"]');
    
    // Check which radio is actually selected and update UI accordingly
    if (subscriptionRadio && subscriptionRadio.checked) {
      // Force trigger change event to ensure proper initialization
      subscriptionRadio.dispatchEvent(new Event('change', { bubbles: true }));
    } else if (oneTimeRadio && oneTimeRadio.checked) {
      oneTimeRadio.dispatchEvent(new Event('change', { bubbles: true }));
    }

    // Enhanced quantity selector interactions
    const quantityOptions = subscriptionComponent.querySelectorAll('.c-subscribtion__quantity-option');
    quantityOptions.forEach(option => {
      option.addEventListener('click', function() {
        const input = this.querySelector('input[type="radio"]');
        if (input && !input.checked) {
          input.checked = true;
          // Trigger change event for the subscription system
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });
  }, 100); // Increased timeout to ensure DOM is fully loaded
});